module.exports = __webpack_public_path__ + "static/media/qr_code_192.6124b56e.svg";